import RotateImage from "../../assets/img/rotate-msg-icon.png";
import React, {memo} from "react";

const PortraitWarning = ({}) => {
    return (<div className={'portrait-warning'}>
        <img alt={''} style={{width: 100, height: 100, top: '35%', position: 'absolute'}}
             src={RotateImage}/>
        <p className={'portrait-message'}>The website is best viewed on landscape mode</p>
    </div>);
}

export default memo(PortraitWarning)